import BaseModel from "../default/base-model";
import { ForecastType } from "./forecast";

export class ImportHistory extends BaseModel {
    import_date?: string;
    file_name?: string;
    user_name?: string;
    is_success?: boolean;
    status_message?: string;
    type?: ForecastType | null;
    customer_name?: string | null;
}

export class RFCExecution extends BaseModel {
    rfc_type?: string;
    execution_date?: string;
    dt_created?: string;
    status?: string;
    operation?: string;
    initiated_by?: number;
    initiated_by_label?: string;
    started_at?: string;
    finished_at?: string;
    execution_log?: string;
    execution_parameters?: any;
    correlation_id?: string;
    error_message?: string;
    duration_seconds?: number;

    get import_date(): string | undefined {
    return this.started_at || this.created_at || this.execution_date;
  }
}

export enum ImportType {
    FORECAST = 1,
    BOM = 2,
    STOCK_PURCHASE_ORDER,
    RFC = 4
}
